import { extend } from 'vee-validate';
import { validator } from './runtime';

extend('phone', {
    ...validator,
    message: 'Please enter correct phone number, valid for the country selected'
});
